import { Plus, Trash2 } from 'lucide-react';
import ConfigField from '../ConfigField';
import { NODE_CONFIG_FIELDS } from '../../../constants';

export default function ManualTriggerConfig({ data, onChange }) {
  const fields = NODE_CONFIG_FIELDS.trigger_manual;
  const customVariables = data.customVariables || [];

  const addVariable = () => {
    onChange('customVariables', [...customVariables, { key: '', label: '' }]);
  };

  const updateVariable = (index, field, value) => {
    const updated = customVariables.map((v, i) =>
      i === index ? { ...v, [field]: value } : v
    );
    onChange('customVariables', updated);
  };

  const removeVariable = (index) => {
    onChange('customVariables', customVariables.filter((_, i) => i !== index));
  };

  return (
    <div className="space-y-4">
      {fields.map((field) => (
        <div key={field.key}>
          <label className="block text-xs font-medium text-gray-600 mb-1.5">{field.label}</label>
          <ConfigField field={field} value={data[field.key]} onChange={(v) => onChange(field.key, v)} allData={data} onChangeField={onChange} />
        </div>
      ))}

      <div className="h-px bg-gray-100 my-1" />
      <div className="flex items-center justify-between">
        <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wide">Custom Variables</p>
        <button
          type="button"
          onClick={addVariable}
          className="flex items-center gap-1 px-2 py-1 text-[11px] font-medium text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-md transition"
        >
          <Plus className="w-3 h-3" />
          Add
        </button>
      </div>
      <p className="text-[10px] text-gray-400">
        Define variables that will be available as <code className="text-blue-600 bg-blue-50 px-1 rounded">{'{{key}}'}</code> in downstream nodes.
      </p>

      {customVariables.length === 0 && (
        <p className="text-xs text-gray-400 text-center py-2">No custom variables defined.</p>
      )}

      {customVariables.map((variable, index) => (
        <div key={index} className="flex items-start gap-2 bg-gray-50 rounded-lg p-2.5">
          <div className="flex-1 space-y-2">
            <input
              type="text"
              value={variable.key}
              onChange={(e) => updateVariable(index, 'key', e.target.value.replace(/[^a-zA-Z0-9_]/g, ''))}
              placeholder="variableName"
              className="w-full px-2.5 py-1.5 text-xs bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-400 font-mono"
            />
            <input
              type="text"
              value={variable.label}
              onChange={(e) => updateVariable(index, 'label', e.target.value)}
              placeholder="Display label (optional)"
              className="w-full px-2.5 py-1.5 text-xs bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-400"
            />
          </div>
          <button
            type="button"
            onClick={() => removeVariable(index)}
            className="p-1.5 text-red-400 hover:text-red-600 hover:bg-red-50 rounded-md transition mt-0.5"
          >
            <Trash2 className="w-3.5 h-3.5" />
          </button>
        </div>
      ))}
    </div>
  );
}
